var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container',{class:['page-wrapper']},[_c('alert',{attrs:{"type":"success"},model:{value:(_vm.comingSoon),callback:function ($$v) {_vm.comingSoon=$$v},expression:"comingSoon"}},[_vm._v(_vm._s(_vm.$lang.underConstruction))]),_vm._v(" "),_c('all-section-blocks',{attrs:{"title":true,"tooltip":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61903bf6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/content/barebone-prop.vue
// module id = null
// module chunks = 